import { observer } from 'mobx-react-lite'
import React, { useContext, useState } from 'react'
import { Pen, ThreeDotsVertical, Trash } from 'react-bootstrap-icons'
import { useNavigate, useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import axiosService from '../../../../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../../../../FormComponents/Toasts'
import EditFolderModal from './EditFolderModal'

export default observer(function FolderDropdownButton({ campaignFolder: campaignFolderProp }) {
  const { campaignState, campaignFolders } = useContext(CampaignContext)
  const { id, campaign_folder_id } = useParams()
  const navigate = useNavigate()
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  const openEditFolderModal = () => setModalOpen(true)

  const deleteFolder = () => {
    axiosService.delete(`/api/project_manager/campaigns/${id}/campaign_folders/${campaignFolderProp.id}`)
    .then(() => {
      campaignState.campaignFolders = campaignFolders.filter(campaignFolder => campaignFolder.id !== campaignFolderProp.id)
      if(+campaign_folder_id === +campaignFolderProp.id) navigate(`/project_manager/campaigns/${id}/files`)
      toastSuccess('Folder deleted')
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <div className="relative">
      <button className="mx-4 p-2 bg-gray-200 rounded-md" onClick={toggleDropdown}><ThreeDotsVertical /></button>
      {dropdownOpen &&
        <div className="absolute bg-green h-full rounded-md flex" style={{ left: -10, bottom: -35 }}>
          <button className="bg-gray-400 text-white py-2 px-3 rounded-l-md z-10 hover:bg-rb-green" onClick={openEditFolderModal}><Pen /></button>
          <button className="bg-gray-400 text-white z-10 py-2 px-3 hover:bg-rb-green rounded-r-md" onClick={deleteFolder}><Trash /></button>
        </div>
      }
      <EditFolderModal open={modalOpen} setOpen={setModalOpen} campaignFolder={campaignFolderProp} toggleDropdown={toggleDropdown} />
    </div>
  )
})